export const FEATURES: Record<string, boolean> = {
  isBaseSpecial: true, // шаблонные страницы базового спеца (team, start, final, quiz)
  onboarding: false, // страница /onboarding
  demo: false, // страница /demo с демонастрацией шаблонных компонентов
  audio: false, // звуки (клики, музыка) в проекте
};
